<template>
  <div class="wrapper">
    <div class="left-area">
      <div class="content">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="right-area only-on-large">
      <div class="drawer">
        <slot name="drawer"></slot>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'tenantGrid',
};
</script>

<style lang="scss" scoped>
  .wrapper {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    gap: 36px;
  }

  .left-area {
    box-sizing: border-box;
    flex: 0 0 56.25%;
    background-color: var(--white);
    display: flex;
    justify-content: flex-end;
    margin-bottom: 12px;
  }

  .right-area {
    box-sizing: border-box;
    flex: 1;
    background-color: var(--gray-100);
  }

  .box {
    margin: 0 auto;
    max-width: 964px;
    display: flex;
    gap: 36px;
  }

  .content {
    flex: 1;
    max-width: 486px;
  }

  .drawer {
    height: 100%;
    width: 370px;
  }

  @media (max-width: $breakpoint-large) {
    .wrapper {
      gap: 0;
    }

    .left-area {
      flex: 1;
    }
  }
</style>
